import { CopyTranslationsPayload } from 'app/area/codetable/item/types';
import { CodetableFeatures } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { getMainLanguageDescription, getMainLanguageLongDescription } from 'app/area/codetable/item/mapping/main-language';

export const mapCopyTranslations =
  (payload: CopyTranslationsPayload, property: keyof CodetableFeatures): CodeComplexValue<number>[] => {
    const { codeItem, languageOptions, mainLanguage } = payload;

    const missingLanguages = getMissingLanguages(codeItem[property], languageOptions);
    const allLanguages = codeItem && isDefinedIncludingZero(codeItem.id) ? [...codeItem[property], ...missingLanguages] : languageOptions;

    const mainLanguageDescription = getMainLanguageDescription(codeItem, mainLanguage);
    const mainLanguageDescriptionText = !!mainLanguageDescription && !!mainLanguageDescription.description
      ? mainLanguageDescription.description.trim()
      : undefined;

    const mainLanguageLongDescription = getMainLanguageLongDescription(codeItem, mainLanguage);
    const mainLanguageLongDescriptionText = !!mainLanguageLongDescription && !!mainLanguageLongDescription.description
      ? mainLanguageLongDescription.description.trim()
      : undefined;

    return allLanguages.map(language => ({
      value: language.value,
      description: property === 'description' ? mainLanguageDescriptionText : mainLanguageLongDescriptionText
    }));
  };

const getMissingLanguages = (source: CodeComplexValue<number>[], compared: CodeComplexValue<number>[]) =>
  compared ? compared.filter(option => !source.some(language => language.value === option.value)) : [];
